// client/src/utils/dateLocale.js
import { registerLocale } from 'react-datepicker';
import { ptBR, enUS, es } from 'date-fns/locale'; // Importe aqui todos os idiomas que seu sistema suporta

// Mapeia as strings de locale (mesmos valores aceitos em
// configuracoesGerais.i18n.locale — ver validLocales no backend,
// accountsController.js::updateAccountI18n) para os objetos de locale
// correspondentes do date-fns.
const locales = {
    'pt-BR': ptBR,
    'en-US': enUS,
    'es-ES': es,
};

// Guarda um registro dos locales que já foram registrados
const registeredLocales = new Set();

// ✅ ACHADO CRÍTICO: esta função recebia uma TIMEZONE (ex:
// "America/Sao_Paulo") e adivinhava o locale por substring — mas o único
// call site real (ContaDashboard.js) já mandava a string de LOCALE
// (ex: "pt-BR", vinda de configuracoesGerais.i18n.locale), que não batia
// em nenhum "includes('Sao_Paulo')" e sempre caía no default 'pt-BR'. Pra
// piorar, o path lido em ContaDashboard.js estava errado
// (configuracoesGerais.locale, quando o campo real fica em
// configuracoesGerais.i18n.locale) — dois bugs se cancelando pro mesmo
// resultado errado-pelo-motivo-certo. Agora recebe o locale diretamente
// e só registra/valida contra o mapa suportado.
/**
 * Valida uma string de LOCALE (ex: "pt-BR", vinda de
 * configuracoesGerais.i18n.locale) contra os idiomas suportados,
 * registra no react-datepicker se necessário, e retorna o locale
 * validado.
 * @param {string} localeString - A string de locale, vinda do i18n da conta.
 * @returns {string} - A string do locale validada (ex: "pt-BR").
 */
export const getAndRegisterDatePickerLocale = (localeString = 'pt-BR') => {
    const resolvedLocale = locales[localeString] ? localeString : 'pt-BR';

    // Só registra o locale se for a primeira vez.
    if (!registeredLocales.has(resolvedLocale)) {
        registerLocale(resolvedLocale, locales[resolvedLocale]);
        registeredLocales.add(resolvedLocale);
    }

    return resolvedLocale;
};
